import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MerriCommonModule } from "@merri/common";
import { AppMaterialModule } from "../app-material.module";
import { PipesModule } from "../pipes/pipes.module";
import { AssetUploadComponent } from "./asset-upload/asset-upload.component";
import { DownloadAllComponent } from "./download-all/download-all.component";
import { DownloadFileFromDataComponent } from "./download-file-from-data/download-file-from-data.component";
import { ErrorWithRefreshComponent } from "./error-with-refresh/error-with-refresh.component";
import { GenerateGuidComponent } from "./generate-guid/generate-guid.component";
import { IconTesterComponent } from "./icon-tester/icon-tester.component";
import { LinkedPartnerUsersDialogComponent } from "./linked-partner-users/linked-partner-users-dialog/linked-partner-users-dialog.component";
import { LinkedPartnersComponent } from "./linked-partners/linked-partners.component";
import { SkuDownloadTemplateComponent } from "./sku-management/sku-download-template/sku-download-template.component";
import { SkuFileUploadComponent } from "./sku-management/sku-file-upload/sku-file-upload.component";
import { SkuManagementComponent } from "./sku-management/sku-management.component";
import { SkuUploadHistoryComponent } from "./sku-management/sku-upload-history/sku-upload-history.component";

@NgModule({
  declarations: [
    SkuManagementComponent,
    SkuUploadHistoryComponent,
    SkuFileUploadComponent,
    SkuDownloadTemplateComponent,
    GenerateGuidComponent,
    DownloadFileFromDataComponent,
    ErrorWithRefreshComponent,
    IconTesterComponent,
    AssetUploadComponent,
    DownloadAllComponent,
    LinkedPartnersComponent,
    LinkedPartnerUsersDialogComponent,
  ],
  imports: [CommonModule, AppMaterialModule, PipesModule, MerriCommonModule, ReactiveFormsModule],
  exports: [
    SkuManagementComponent,
    DownloadFileFromDataComponent,
    ErrorWithRefreshComponent,
    IconTesterComponent,
    AssetUploadComponent,
    DownloadAllComponent,
    SkuFileUploadComponent,
    SkuDownloadTemplateComponent,
    LinkedPartnersComponent,
  ],
})
export class ComponentsModule {}
